import Scene7ImageIcon from './Scene7ImageIcon';

export default Scene7ImageIcon;
